// extracted by mini-css-extract-plugin
module.exports = {"comp":"P_comp__sQqDV"};